// extracted by css-extract-rspack-plugin
export default {"Overlay":"user-notice-popover-module__Overlay__Hg8IH4a"};